// The phone: the pane of one caster in a match, under the board. It is the
// pane of the caster select with no pick button: the symbol, the name, and
// each skill with its vessel, its name, and its blurb. A tap on a caster in a
// team sheet opens it, see `state/casterRead.ts`. The cross closes it.

import { casterById } from '../content/casters';
import { el } from '../lib/dom';
import { casterReadStore, closeCasterRead } from '../state/casterRead';
import { createCasterPane } from './CasterPane';
import { createCloseButton } from './CloseButton';

export const createCasterRead = (): HTMLElement => {
  const pane = createCasterPane();
  const root = el('section', { className: 'caster-read' }, [
    pane.root,
    createCloseButton(closeCasterRead),
  ]);

  const draw = (id: ReturnType<typeof casterReadStore.get>): void => {
    root.hidden = id === null;
    if (id === null) return;
    const caster = casterById(id);
    root.ariaLabel = caster.name;
    pane.draw({ caster, picked: false, full: false, onToggle: null });
  };

  draw(casterReadStore.get());
  casterReadStore.subscribe(draw);
  return root;
};
